import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import TextInput from "../../../../Input/TextInput/index";
import { jsx as _jsx } from "react/jsx-runtime";
function TextInputCell(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(TextInput, _extends({}, props));
}
export default TextInputCell;